<template>
  <el-container class="home">
    <el-header class="header">
      <Header />
    </el-header>
    <el-container>
      <el-aside width="200px">
        <Sider />
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <el-footer class="footer" height="50px">
      <Footer />
    </el-footer>
  </el-container>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Sider from '@/components/Sider.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header, Sider, Footer
  }
}
</script>

<style lang="less" scoped>
.home {
  height: 100%;
}
.header,
.footer {
  margin: 0;
  padding: 0;
}
</style>
